import React from 'react';
import { Grid, Typography, Divider, Paper } from '@mui/material';
import Masonry from '@mui/lab/Masonry';
import '../../../styles/report.css';
import DynamicComponent from '../DynamicComponent';
import { motion } from "framer-motion/dist/framer-motion";

const PrintStyles = () => (
    <style>
        {`
        @media print {
            .masonry-print-paper {
                padding: 20px;
                border: 0px solid #ccc;
                background-color: #fff;
            }
            .masonry-print-title {
                text-align: center;
                font-size: 18pt;
                font-family: 'Times New Roman', Times, serif;
                font-weight: bold;
                color: #000;
            }
            .masonry-print-divider {
                margin: 8px 0 16px 0;
                border-color: #ccc !important;
            }
            /* This robust CSS Grid should now work correctly on the simplified JSX */
            .masonry-print-container {
                display: grid !important;
                grid-template-columns: 1fr 1fr; /* Create two equal-width columns */
                gap: 20px; /* Space between columns and rows */
            }
            .masonry-print-container > * {
                break-inside: avoid; /* Prevents items from splitting across columns */
            }
        }
        `}
    </style>
);

const MasonrySection = (props) => {
    const { component, elevationdisabled, PrintView } = props;
    const OrderedSections = [...component.Sections].sort((a, b) => parseInt(a.Order) - parseInt(b.Order));
    const FilteredSections = OrderedSections.filter((a) => a.Visible === '1');
    
    const motionVariants = {
        hidden: { opacity: 0, x: 0, y: 0 },
        show: {
            opacity: 1, x: 0, y: 0,
            transition: {
                delay: 0.1,
                duration: 0.5,
            }
        }
    };

    if (PrintView === true) {
        // CORRECTED: The entire print view is now wrapped in a simple div, not an MUI Grid item.
        return (
            <div>
                <PrintStyles />
                <div className="masonry-print-paper">
                    <Typography className="masonry-print-title">{component.Label}</Typography>
                    <Divider orientation='horizontal' className="masonry-print-divider" />
                    <div className="masonry-print-container">
                        {FilteredSections && FilteredSections.map((displayValues, index) => (
                            <DynamicComponent component={displayValues} key={index} PrintView={PrintView} />
                        ))}
                    </div>
                </div>
            </div>
        );
    }

    // Original screen view remains unchanged
    return (
        <Grid item lg={12} md={12} sm={12} xs={12} sx={{ padding: '10px' }}>
            <motion.div variants={motionVariants} initial="hidden" animate="show" style={{ height: '100%' }}>
                <Paper elevation={elevationdisabled === true ? 0 : 1} sx={{ padding: '40px', height: '100%' }}>
                    <Grid container direction="row" alignItems="top" justifyContent="center" spacing={2} >
                        <Grid item xs={12}>
                            <Typography variant="h5" align="center">{component.Label}</Typography>
                        </Grid>
                        <Grid item xs={12} m={1}>
                            <Divider orientation='horizontal' sx={{ borderColor: "rgba(0,0,0,0.1)", borderRadius: '90%', borderBottomWidth: 2 }} />
                        </Grid>
                        <Grid item xs={12}>
                            <Masonry columns={{ xs: 1, sm: 2, md: 3 }} spacing={1} >
                                {FilteredSections && FilteredSections.map((displayValues, index) => (
                                    <DynamicComponent component={displayValues} key={index} PrintView={PrintView} />
                                ))}
                            </Masonry>
                        </Grid>
                    </Grid>
                </Paper>
            </motion.div>
        </Grid>
    );
}

export default MasonrySection;